const VERSION = "previousVersion";

export const saveVersion = (version: string) => {
  localStorage.setItem(VERSION, version);
};

export const changeVersionState = () => {
  localStorage.setItem(VERSION, "DONE");
};

export const checkVersionState = () => {
  return localStorage.getItem(VERSION) !== "DONE";
};

export const checkVersion = (version: string) => {
  const previousVersion = localStorage.getItem(VERSION) || "0";
  return (
    parseInt(version.replace(".", "")) >
    parseInt(previousVersion.replace(".", ""))
  );
};

export default {
  checkVersionState,
  saveVersion,
  changeVersionState,
  checkVersion,
};
